/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import PropTypes from "prop-types";

import React from "react";

import classNames from "classnames";

// TODO: Add in helptip once we have popovers
export default class extends React.Component {
  static displayName = "KPICard";

  static propTypes = {
    title: PropTypes.node.isRequired,
    value: PropTypes.node,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    disableBorderRight: PropTypes.bool,
    children: PropTypes.any,
  };

  static defaultProps = { width: 25 };

  render() {
    return (
      <div
        className={classNames("et--kpi-card", this.props.className)}
        style={{ width: this.props.width + "%", ...(this.props.disableBorderRight && { borderRight: "none" }) }}
      >
        <span className="et--kpi-card--title">{this.props.title}</span>
        {typeof this.props.value !== "undefined" && <h3 className="et--kpi-card--value">{this.props.value}</h3>}
        {this.props.children}
      </div>
    );
  }
}
